var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 13.25C20.75 14.9806 20.2368 16.6723 19.2754 18.1112C18.3139 19.5502 16.9473 20.6717 15.3485 21.3339C13.7496 21.9962 11.9903 22.1695 10.293 21.8319C8.59563 21.4943 7.03653 20.6609 5.81282 19.4372C4.58911 18.2135 3.75575 16.6544 3.41813 14.957C3.08051 13.2597 3.25379 11.5004 3.91606 9.90152C4.57832 8.30267 5.69983 6.9361 7.13876 5.97464C8.57769 5.01318 10.2694 4.5 12 4.5C14.3204 4.5008 16.5455 5.42292 18.1863 7.06369C19.8271 8.70446 20.7492 10.9296 20.75 13.25V13.25Z",
    stroke: "#FAF0E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8V13",
    stroke: "#FAF0E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H15",
    stroke: "#FAF0E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.e72186b5.svg";
export { ForwardRef as ReactComponent };